<!--eslint-disable-next-line-->
<template>
</template>

<script>
import {HTTP} from '@/backend/client'

export default {
  name: 'Logout',
  created () {
    HTTP.defaults.headers.common['Authorization'] = null
    this.$store.dispatch('appcurrent/deleteAuthorization')
    this.$router.push('/Login')
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Logout.vue